import { useState, useEffect } from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { EditPage, EditPagePanel, EditPageSelect } from './../../../../common/EditPage';
import { useParams, useNavigate } from 'react-router-dom';
import { getOne, update } from './../../../../common/v4/BackendProvider';
import { toast } from 'react-toastify';

const ClientAccountNumbersEdit = () => {
    const [metadata, setMetadata] = useState({});
    const [data, setData] = useState({});
    const { account_id, id } = useParams();
    const navigate = useNavigate();

    useEffect(() => {
        getOne(`/admin/clients/clients/${account_id}/numbers/`, id).then(response => {
            setData(response.data.data);
            setMetadata(response.data.metadata);
        }).catch(error => {
            toast.error("Error fetching number: " + error.message, {});
        });
    }, [account_id, id]);

    const handleSave = () => {
        update(`/admin/clients/clients/${account_id}/numbers/`, id, {data: data}).then(() => {
            toast.success("Number updated successfully", {});
            navigate(`/clients/clients/${account_id}/numbers`);
        }).catch(error => {
            toast.error("Error updating number: " + error.message, {});
        });
    };

    const handleCancel = () => {
        navigate(`/clients/clients/${account_id}/numbers`);
    }

    const onChange = (id, value) => {
        setData({ ...data, [id]: value });
    }

    return (
        <>
            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                closeOnClick={true}
                pauseOnHover={true}
                draggable={true}
                progress="undefined"
            />
            <EditPage handleSave={ handleSave } handleCancel={ handleCancel } >
                <EditPagePanel>
                    <EditPageSelect 
                        label="SMPP Account" 
                        id="smpp_account_id" 
                        onChange={ onChange } 
                        value={ data.smpp_account_id } 
                        options={ metadata?.smpp_account_id?.values } 
                        nullable={ true } 
                    />
                </EditPagePanel>
            </EditPage>
        </>
    )
}   

export default ClientAccountNumbersEdit;
